<!-- 改厕档案信息查看 -->

<template>
    <div class="main-area">
        <el-breadcrumb separator=":">
            <el-breadcrumb-item>当前位置</el-breadcrumb-item>
            <el-breadcrumb-item>改厕档案信息查看</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack" content="基本信息" class="margin-top-20"></el-page-header>
        <el-form
            :inline="true"
            :model="formData"
            class="demo-ruleForm"
            label-width="100px"
            :rules="formRules"
            ref="formData"
            :size="GLOBAL.config.systemSize"
            element-loading-text="数据处理中...请稍等..."
            :disabled="!editableFlag"
            v-loading="loading">
            <el-row class="margin-top-10">
                <el-col :span="8">
                    <el-form-item label="区划：" prop="ssqhName">
                        <el-input v-model="formData.ssqhName" placeholder="" maxlength="64"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="改厕户姓名：" prop="hz">
                        <el-input v-model="formData.hz" placeholder="" maxlength="64"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="手机号码：" prop="hzsjh">
                        <el-input v-model="formData.hzsjh" placeholder="" maxlength="64"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="margin-top-10">
                <el-col :span="8">
                    <el-form-item label="建档时间：" prop="cjsj">
                        <el-input v-model="formData.cjsj" placeholder="" maxlength="64"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="身份证号：" prop="hzsfz">
                        <el-input v-model="formData.hzsfz" placeholder="" maxlength="64"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="改厕编号：" prop="gcbh">
                        <el-input v-model="formData.gcbh" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="margin-top-10">
                <el-col :span="8">
                    <el-form-item label="改厕日期：" prop="gcrq">
                        <el-input v-model="formData.gcrq" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="详细地址：" prop="wzdw">
                        <el-input v-model="formData.wzdw" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="改厕状态：" prop="gczt">
                        <el-select disabled v-model="formData.gczt" placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;" @change="change1()">
                            <el-option
                            v-for="item in dictionary.gczts"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="margin-top-10">
                <el-col :span="8">
                    <el-form-item label="改厕类型：" prop="gclx">
                        <el-select disabled v-model="formData.gclx" placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;" @change="change2()">
                            <el-option
                            v-for="item in dictionary.gclxs"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="清掏方式：" prop="qtfs">
                        <el-select disabled v-model="formData.qtfs" placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;" @change="change3()">
                            <el-option
                            v-for="item in dictionary.qtfss"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-divider v-if="imageList.length > 0" content-position="left">档案照片</el-divider>
        <div style="width: 100%; text-align: left">
          <img v-for="(item, index) in imageList" :key="index" :src="item.url" @click="previewImage(item.url)" width="100px" height="100px" style="margin-left: 20px; cursor: pointer;">
        </div>
        <el-divider content-position="left">报修信息</el-divider>
        <el-table style="width: 100%"
                :data="bxTableData"
                element-loading-text="数据处理中...请稍等..."
                v-loading="loading">
            <!--序号-->
            <el-table-column type="index" label="序号" width="80px" align="center"/>
            <el-table-column prop="bxsj" label="报修时间" align="center" :formatter="formatterTime"/>
            <el-table-column prop="zt" label="状态" align="center" :formatter="formatterBXStatus"/>
            <el-table-column prop="dcrUuidName" label="维修责任人" align="center"/>
            <el-table-column prop="gzms" label="报修描述" align="center"/>
            <el-table-column prop="pj" label="评价" align="center">
                <template slot-scope="scope" >
                    <el-rate v-model="scope.row.pj" :allow-half="true"  disabled text-color="#000000" :colors="['#000000', '#000000', '#000000']"></el-rate>
                </template>
            </el-table-column>
            <el-table-column label="相关照片" align="center">
                <template slot-scope="scope">
                  <div style="color: #2b68e4; cursor:pointer;" @click="handlePreview(scope.row)">查看照片</div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="margin-top-10 margin-bottom-20"
            @size-change="bxTableSizeChange"
            @current-change="bxCurrentChange"
            :current-page="bxPagination.currentPage"
            :page-sizes="bxPagination.pageSizeList"
            :page-size="bxPagination.pageSize"
            :layout="bxPagination.layout"
            :total="bxPagination.total">
        </el-pagination>

        <el-divider content-position="left">报抽信息</el-divider>
        <el-table style="width: 100%"
                :data="bcTableData"
                element-loading-text="数据处理中...请稍等..."
                v-loading="loading">
            <!--序号-->
            <el-table-column type="index" label="序号" width="80px" align="center"/>
            <el-table-column prop="bcsj" label="报抽时间" align="center" :formatter="formatterTime"/>
            <el-table-column prop="zt" label="状态" align="center" :formatter="formatterBCStatus"/>
            <el-table-column prop="dcrUuidName" label="抽粪责任人" align="center"/>
            <el-table-column prop="cqcName" label="抽粪责任车辆" align="center"/>
            <el-table-column prop="pj" label="评价" align="center">
                <template slot-scope="scope" >
                    <el-rate v-model="scope.row.pj" :allow-half="true"  disabled text-color="#000000" :colors="['#000000', '#000000', '#000000']"></el-rate>
                </template>
            </el-table-column>
            <el-table-column label="相关照片" align="center">
              <template slot-scope="scope">
                <div style="color: #2b68e4; cursor:pointer;" @click="handlePreview(scope.row)">查看照片</div>
              </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="margin-top-10 margin-bottom-20"
            @size-change="bcTableSizeChange"
            @current-change="bcCurrentChange"
            :current-page="bcPagination.currentPage"
            :page-sizes="bcPagination.pageSizeList"
            :page-size="bcPagination.pageSize"
            :layout="bcPagination.layout"
            :total="bcPagination.total">
        </el-pagination>
      <el-divider content-position="left">巡查信息</el-divider>
      <el-table style="width: 100%"
                :data="xcTableData"
                element-loading-text="数据处理中...请稍等..."
                v-loading="loading">
        <!--序号-->
        <el-table-column type="index" label="序号" width="80px" align="center"/>
        <el-table-column prop="xcxm" label="巡查人姓名" align="center"/>
        <el-table-column prop="cjsj" label="巡查时间" align="center" :formatter="formatterTime"/>
        <el-table-column prop="sfzc" label="巡查结果" align="center">
          <template slot-scope="scope">
            {{ scope.row.sfzc === '0'?'不正常':'正常' }}
          </template>
        </el-table-column>
        <el-table-column prop="bz" label="户主反馈" align="center">
          <template slot-scope="scope">
            {{ scope.row.bz === '1'?'不满意':(scope.row.bz === '2'?'一般':'满意') }}
          </template>
        </el-table-column>
        <el-table-column label="相关照片" align="center">
          <template slot-scope="scope">
            <div style="color: #2b68e4; cursor:pointer;" @click="handlePreviewXc(scope.row)">查看照片</div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="margin-top-10 margin-bottom-20"
        @size-change="xcTableSizeChange"
        @current-change="xcCurrentChange"
        :current-page="xcPagination.currentPage"
        :page-sizes="xcPagination.pageSizeList"
        :page-size="xcPagination.pageSize"
        :layout="xcPagination.layout"
        :total="xcPagination.total">
      </el-pagination>
        <ImagePreview ref="imagePreview"></ImagePreview>
        <PreviewWorkbench ref="previewWorkbench"></PreviewWorkbench>
        <PreviewXcImage ref="PreviewXcImage"></PreviewXcImage>
    </div>
</template>

<script>
import ImagePreview from "../../components/ImagePreview"
import PreviewWorkbench from "../../components/PreviewWorkbench"
import PreviewXcImage from "../../components/PreviewXcImage"
export default {
    name: 'GCArchivesInfo',
    components: {
        ImagePreview,
        PreviewWorkbench,
        PreviewXcImage
    },
    data() {
        return {
            editableFlag: false,
            loading: false,
            formData: {
                // 区划
                ssqhName: "",
                // 户主姓名
                hz: "",
                hzsjh: "",
                // 建档时间
                cjsj: "",
                // 详细地址
                wzdw: ""
            },
            imageList: [],
            bxTableData: [],
            bcTableData: [],
            xcTableData: [],
            formRules: {

            },
            // 报修分页参数
            bxPagination: {
                pageSizeList: [10, 20, 30, 40, 50],
                pageSize: 10,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0,
                currentPage: 1
            },
            // 报抽分页参数
            bcPagination: {
                pageSizeList: [10, 20, 30, 40, 50],
                pageSize: 10,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0,
                currentPage: 1
            },
          // 巡查分页参数
          xcPagination: {
            pageSizeList: [10, 20, 30, 40, 50],
            pageSize: 10,
            layout: 'total, sizes, prev, pager, next, jumper',
            total: 0,
            currentPage: 1
          },
            // 列表传递参数
            gcArchivesInfo: {},
            uuid: '',
            hzsfz: '',
            dictionary: {
                // 改厕状态
                gczts: JSON.parse(unescape(localStorage.getItem("GC_TYPE"))),
                // 改厕类型
                gclxs: JSON.parse(unescape(localStorage.getItem("GC_LX"))),
                // 清掏方式
                qtfss: JSON.parse(unescape(localStorage.getItem("ZX_QT")))
            }
        }
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },
        // 报修分页方法
        bxTableSizeChange: function (pageSize) {
            this.bxPagination.pageSize = pageSize
            this.getBXData()
        },
        bxCurrentChange: function (current) {
            this.bxPagination.currentPage = current
            this.getBXData()
        },
        // 报抽分页方法
        bcTableSizeChange: function (pageSize) {
            this.bcPagination.pageSize = pageSize
            this.getBCData()
        },
        bcCurrentChange: function (current) {
            this.bcPagination.currentPage = current
            this.getBCData()
        },
      // 巡查分页方法
      xcTableSizeChange: function (pageSize) {
        this.xcPagination.pageSize = pageSize
        this.getXCData()
      },
      xcCurrentChange: function (current) {
        this.xcPagination.currentPage = current
        this.getXCData()
      },
        // 获取基本信息
        getBaseData() {
            let _this = this;
            let param = {
                info: _this.uuid,
                baseService: 'TGcGcdaServiceImpl',
                type: _this.GLOBAL.config.handleType.getInfoById,
            }
            _this.FUNCTIONS.systemFunction.jsonPost(
                _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                param,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        _this.imageList = resultData.obj.TGcFj ? resultData.obj.TGcFj : [];
                        _this.formData = resultData.obj.TGcGcda;
                        _this.formData.cjsj = _this.formatterTime(null, null, _this.formData.cjsj);
                    } else {

                    }
                }
            )
        },
        // 获取报修信息
        getBXData(initPageFlag) {
            let _this = this;
            // 3、 调接口获取数据
            let param = {
                baseService : "TGcBxxxServiceImpl",
                current: initPageFlag ? 1 : _this.bxPagination.currentPage,
                size: initPageFlag ? 10 : _this.bxPagination.pageSize,
                records: [{daUuid: _this.hzsfz}]

            }
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.getPageNew,
                param,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // 结果参数赋值
                        _this.bxTableData = resultData.obj.records;
                        _this.bxPagination.pageSize = resultData.obj.size
                        _this.bxPagination.total = resultData.obj.total
                        _this.bxPagination.currentPage = resultData.obj.current
                        for (const i in _this.bxTableData) {
                            if (_this.bxTableData[i].pj) {
                                _this.bxTableData[i].pj = parseInt(_this.bxTableData[i].pj);
                            }
                        }
                    } else {
                        _this.$message.warning('获取列表数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
        // 获取报抽信息
        getBCData(initPageFlag) {
            let _this = this;
            // 3、 调接口获取数据
            let param = {
                baseService : "TGcBcxxServiceImpl",
                current: initPageFlag ? 1 : _this.bcPagination.currentPage,
                size: initPageFlag ? 10 : _this.bcPagination.pageSize,
                records: [{daUuid: _this.hzsfz}]

            }
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.getPageNew,
                param,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // 结果参数赋值
                        _this.bcTableData = resultData.obj.records;
                        _this.bcPagination.pageSize = resultData.obj.size
                        _this.bcPagination.total = resultData.obj.total
                        _this.bcPagination.currentPage = resultData.obj.current
                        for (const i in _this.bcTableData) {
                            if (_this.bcTableData[i].pj) {
                                _this.bcTableData[i].pj = parseInt(_this.bcTableData[i].pj);
                            }
                        }
                    } else {
                        _this.$message.warning('获取列表数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
      // 获取巡查信息
      getXCData(initPageFlag) {
        let _this = this;
        // 3、 调接口获取数据
        let param = {
          baseService : "TGcXcjlServiceImpl",
          current: initPageFlag ? 1 : _this.bcPagination.currentPage,
          size: initPageFlag ? 10 : _this.bcPagination.pageSize,
          records: [{daUuid: _this.hzsfz}]

        }
        _this.FUNCTIONS.systemFunction.interactiveData(
          _this,
          _this.GLOBAL.config.businessFlag.zxUser,
          _this.GLOBAL.config.handleType.getXcById,
          param,
          null,
          resultData => {
            _this.loading = false
            if (resultData) {
              // 结果参数赋值
              _this.xcTableData = resultData.obj.records;
              _this.xcPagination.pageSize = resultData.obj.size
              _this.xcPagination.total = resultData.obj.total
              _this.xcPagination.currentPage = resultData.obj.current
              // for (const i in _this.bcTableData) {
              //   if (_this.bcTableData[i].pj) {
              //     _this.bcTableData[i].pj = parseInt(_this.bcTableData[i].pj);
              //   }
              // }
            } else {
              _this.$message.warning('获取列表数据失败～')
            }
          },
          () => {
            _this.loading = false
          }
        )
      },
        // 查看图片
        previewImage: function (url) {
            this.$refs.imagePreview.handlePictureCardPreview(url)
        },
        // 请求报抽报修照片
        handlePreview: function (rowData) {
            this.$refs.previewWorkbench.requestImageData(rowData.uuid)
        },
        // 请求巡查照片
        handlePreviewXc: function (rowData) {
          this.$refs.PreviewXcImage.requestImageData(rowData.uuid)
        },
        formatterTime(row, column, data) {
            if (!data) {
                return "";
            }
            var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
            return data.replace(reg, "$1-$2-$3 $4:$5:$6");
        },
        formatterBXStatus(row, column, data) {
            let str = "";
            switch (data) {
                case '0':
                    str = "未修"
                    break;
                case '1':
                    str = "已修"
                    break;
                case '2':
                    str = "撤回"
                    break;
                default:
                    break;
            }
            return str;
        },
        formatterBCStatus(row, column, data) {
            let str = "";
            switch (data) {
                case '0':
                    str = "未抽"
                    break;
                case '1':
                    str = "已抽"
                    break;
                case '2':
                    str = "撤回"
                    break;
                default:
                    break;
            }
            return str;
        }
    },
    mounted() {
      // debugger
        this.gcArchivesInfo = this.$route.params.gcArchivesInfo;
        this.uuid = this.$route.params.gcArchivesInfo.uuid;
        this.hzsfz = this.$route.params.gcArchivesInfo.hzsfz;
        this.getBaseData();
        this.getBXData('init');
        this.getBCData('init');
        this.getXCData('init');
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/GCArchivesInfo/GCArchivesInfo.vue